var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7321_9399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.54125C14.5 5.35986 11.8139 2.78125 8.5 2.78125C5.18605 2.78125 2.5 5.35986 2.5 8.54125C2.5 11.7226 5.18605 14.3013 8.5 14.3013C11.8139 14.3013 14.5 11.7226 14.5 8.54125Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1721 7.50479V7.45743C10.1721 7.00412 9.78936 6.63672 9.31716 6.63672H7.86223C7.2921 6.63672 6.82959 7.08008 6.82959 7.62805C6.82959 8.17544 7.2921 8.61941 7.86223 8.61941H9.17963C9.72776 8.61941 10.1727 9.04597 10.1727 9.57212C10.1727 10.099 9.72776 10.5255 9.17963 10.5255H7.6845C7.2123 10.5255 6.82959 10.1575 6.82959 9.70415",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.94922V11.1332",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7321_9399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/funding.ecbf8bc76c68bef8fc2fad7e0dd29ab1.svg";
export { ForwardRef as ReactComponent };